import { Injectable } from '@angular/core';

/**
 * @deprecated This class is deprecated please use `LanguageService` instead.
 */
@Injectable({ providedIn: 'root' })
export class Globals {
  language: string = 'es-mx';
}

export const LANGUAGES = {
  ES_MX: 'es-mx',
  EN_US: 'en-us',
};
